import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseOrganizationRestrictionRemoved } from 'entities/Organization/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventOrganizationRestrictionRemoved = () => {
  const { organizationStore, subscriptionStore, websocket } = useEntitiesContext()
  const handle = async (data: IResponseOrganizationRestrictionRemoved) => {
    if (data.restriction_type) {
      organizationStore.updateOrganizationNumbersGracePeriod(false)
      await subscriptionStore.init()
    }
  }

  useEffect(() => {
    websocket.on(WebsocketEvent.OrganizationRestrictionRemoved, handle)
    return () => websocket.off(WebsocketEvent.OrganizationRestrictionRemoved, handle)
  }, [])
}
